<template>
    <div class="card shadow-sm mb-5 p-5 card-flush overflow-hidden h-md-100">
      <button v-if="remove"
          type="button"
          class="btn-close position-absolute top-0 end-0 mt-2 me-4"
          aria-label="Remove"
          @click="remove"/>

        <div class="card-header">
        <div class="card-title">
            <h5 style="text-align: start">{{ title }}</h5>
        </div>
        </div>
        <Loader :is-loading="loading">
          <div class="card-body">
              <div class="row">
                <div class="col-12 col-md-6 col-lg-3" v-for="(status, index) in getTotalAppointmentsByStatus" :key="index">
                 <div class="card px-5 py-3 mb-2 bg-light-primary">
                  <div class="d-flex flex-column flex-md-row flex-wrap justify-content-between align-items-center gap-3">
                    <div class="flex-grow-1">
                      <a class="text-black fs-5 fw-bold text-center text-md-start d-block">
                        {{ filterStatus(status.name) ? filterStatus(status.name)[locale] : $t('estimate.total') }}
                      </a>
                    </div>
                    <div class="symbol symbol-sm-20px symbol-md-30px symbol-lg-40px">
                      <div
                        class="symbol-label fs-6 fs-md-4 py-2 px-4 px-md-5 text-white text-center"
                        :class="filterStatus(status.name) ? 'bg-' + filterStatus(status.name)?.color : 'bg-black'"
                      >
                        {{ status.total }}
                      </div>
                    </div>
                  </div>
                </div>
                </div>
              </div>
          </div>
        </Loader>
    </div>  
</template>
<script setup>
import Loader from '@/components/Loader.vue';
import { useLocales } from '@/composables/locales';
import { computed, watch, onMounted, ref} from 'vue';
import { useStore } from 'vuex';

const store = useStore()
const {locale} = useLocales()

const props = defineProps({
  id:{type: String, required: true},
  title:{type: String, required: true},
  loading:{type: Boolean, default: false},
  loadStats:{type: Function, required: true},
  remove:{type: Function},
  start: { type: Date, required: false },
  end: { type: Date, required: false },

})
  
const query = ref({
    start_date: '',
    end_date: '',
    creator_id: ''
})

const getTotalAppointmentsByStatus = ref([])

const appointmentStatus = computed(() => store.getters['appointments/appointmentStatus'])

watch(() => [props.start, props.end], () => {
 if(props.start) query.value.start_date = props.start
 if(props.end) query.value.end_date = props.end
})

watch(() => query.value, () => {
  if (query.value.start_date && query.value.end_date) {
    loadData();
  }
}, {deep: true})

function loadData(){
  if (!query.value.start_date || !query.value.end_date) {
    console.warn("Dates non définies, loadData ignorée");
    return;
  }
  
    Promise.all([ 
        props.loadStats({id:props.id,startDate: query.value.start_date, endDate: query.value.end_date, creator_id: query.value.creator_id}).then((res) => {
          let answer = res.response?.data || res?.data?.getTotalAppointmentsByStatus
          
          getTotalAppointmentsByStatus.value = answer?.filter(item => item.name != 'SCHEDULED')
        }),
        store.dispatch('appointments/loadAppointmentStatus'),

    ]).then(() => {
    })
}

function filterStatus(value) {
    let statistic = appointmentStatus.value.find(status => status.value === value);
    return statistic;
  }

onMounted(() => {
  if(props.start) query.value.start_date = props.start
  if(props.end) query.value.end_date = props.end 
})
</script>